import { BASE_URL } from "../config/config";

export const fetchCollections = async () => {
    try {
        const response = await fetch(`${BASE_URL}/collections`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching Collections:', error);
        throw error;
    }
};

export const fetchCollection = async (slug) => {
    try {
        const response = await fetch(`${BASE_URL}/collections/${slug}`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching Collection:', error);
        throw error;
    }
};